import type React from "react";
import EmptyStatus from "@imminently/decisively-ui/EmptyStatus";
import Button from "@imminently/decisively-ui/Button";
import Icon from "@imminently/decisively-ui/Icon";
import { useTranslation } from "react-i18next";
import { useErrorReporting } from "@/ErrorReporting";
import { cn } from "@/lib/utils";
import Markdown from "react-markdown";

export interface ErrorInfoProps {
  children?: React.ReactNode;
  className?: string;
}

export const ReportIssue = () => {
  const { t } = useTranslation();
  const errorReporting = useErrorReporting();
  return (
    <Button
      variant="outline"
      onClick={() => errorReporting?.open()}
      label={t("fallback_report_issue")}
    />
  );
};

export const ErrorInfo = ({ children, className }: ErrorInfoProps) => {
  const { t } = useTranslation();
  return (
    <EmptyStatus className={cn("bg-card text-card-foreground border rounded-xl shadow-sm p-8", className)}>
      <EmptyStatus.Graphic>
        <Icon name="error" className="size-16 text-destructive" />
      </EmptyStatus.Graphic>
      <EmptyStatus.Title>{t("fallback_error_title")}</EmptyStatus.Title>
      <EmptyStatus.Content>
        {
          children
            ? children
            : (
              <>
                <p className="text-center text-muted-foreground">{t("fallback_error_body")}</p>
                <div className="flex flex-row items-center gap-1">
                  <ReportIssue />
                  <Button label={t("fallback_error_go_home")} asChild variant="outline" intent="secondary">
                    <a href="/">
                      {t("fallback_error_go_home")}
                    </a>
                  </Button>
                </div>
                <p className="text-center font-medium mt-8">{t("fallback_error_next")}</p>
                <ul className="list-disc pl-5 text-left [&_a]:underline [&>li]:text-base [&>li]:leading-6 [&>li]:font-normal">
                  <li>{t("fallback_error_refresh")}</li>
                  <li><Markdown>{t("fallback_error_contact")}</Markdown></li>
                </ul>
              </>
            )
        }
      </EmptyStatus.Content>
    </EmptyStatus>
  );
};
